const script = {}

export default script